/*
 *
 * Teams constants
 *
 */

export const DEFAULT_ACTION = 'app/Teams/DEFAULT_ACTION';

export const CREATE_TEAM = 'app/Teams/CREATE_TEAM';
export const CREATE_TEAM_SUCCESS = 'app/Teams/CREATE_TEAM_SUCCESS';
export const CREATE_TEAM_FAILURE = 'app/Teams/CREATE_TEAM_FAILURE';

export const CHANGE_TEAMS_VISIBILITY = 'app/Teams/CHANGE_TEAM_VISIBILITY';

export const RESET_STATE = 'app/Teams/RESET_STATE';
